let map;

window.googlemapsInterop = {
    loadGoogleMaps: (apiKey) =>
    {
        return new Promise((resolve, reject) =>
        {
            if (document.getElementById('google-maps-script'))
            {
                resolve(); // Already loaded
                return;
            }

            const script = document.createElement('script');
            script.id = 'google-maps-script';
            script.src = `https://maps.googleapis.com/maps/api/js?key=${apiKey}`;
            script.async = true;
            script.defer = true;
            script.onload = resolve;
            script.onerror = reject;

            document.head.appendChild(script);
        });


    },

    initMapWithOptions: async (mapOptions) =>
    {
        await initMapWithOptions(mapOptions);
    }

}

async function initMapWithOptions(mapOptions)
{
    const nightModeStyle = [
        { elementType: "geometry", stylers: [{ color: "#242f3e" }] },
        { elementType: "labels.text.stroke", stylers: [{ color: "#242f3e" }] },
        { elementType: "labels.text.fill", stylers: [{ color: "#746855" }] },
        {
            featureType: "administrative.locality",
            elementType: "labels.text.fill",
            stylers: [{ color: "#d59563" }],
        },
        {
            featureType: "poi",
            elementType: "labels.text.fill",
            stylers: [{ color: "#BCBEC2" }],
        },
        
        {
            featureType: "poi.park",
            elementType: "geometry",
            stylers: [{ color: "#263c3f" }],
        },
        {
            featureType: "poi.park",
            elementType: "labels.text.fill",
            stylers: [{ color: "#6b9a76" }],
        },
        {
            featureType: "road",
            elementType: "geometry",
            stylers: [{ color: "#38414e" }],
        },
        {
            featureType: "road",
            elementType: "geometry.stroke",
            stylers: [{ color: "#212a37" }],
        },
        {
            featureType: "road",
            elementType: "labels.text.fill",
            stylers: [{ color: "#9ca5b3" }],
        },
        {
            featureType: "road.highway",
            elementType: "geometry",
            stylers: [{ color: "#746855" }],
        },
        {
            featureType: "road.highway",
            elementType: "geometry.stroke",
            stylers: [{ color: "#1f2835" }],
        },
        {
            featureType: "road.highway",
            elementType: "labels.text.fill",
            stylers: [{ color: "#f3d19c" }],
        },
        {
            featureType: "transit",
            elementType: "geometry",
            stylers: [{ color: "#2f3948" }],
        },
        {
            featureType: "transit.station",
            elementType: "labels.text.fill",
            stylers: [{ color: "#d59563" }],
        },
        {
            featureType: "water",
            elementType: "geometry",
            stylers: [{ color: "#17263c" }],
        },
        {
            featureType: "water",
            elementType: "labels.text.fill",
            stylers: [{ color: "#515c6d" }],
        },
        {
            featureType: "water",
            elementType: "labels.text.stroke",
            stylers: [{ color: "#17263c" }],
        },
       
        {
            featureType: "poi.business",
            stylers: [{ color: "#898989" }, {visibility: "off"}],
        },
        {
            featureType: "poi.attraction",
            stylers: [
                { visibility: "off" }
            ]
        },
        {
            featureType: "poi.school",
            stylers: [
                { visibility: "off" }
            ]
        },
        {
            featureType: "poi.medical",
            stylers: [
                { visibility: "off" }
            ]
        },
        
       
    ];

    const mapOptionsConfig = {
        center: { lat: mapOptions.latitude, lng: mapOptions.longitude },
        zoom: mapOptions.zoom,
        styles: mapOptions.nightMode ? nightModeStyle : [],
        disableDefaultUI: mapOptions.disableDefaultUI, 
        zoomControl: mapOptions.zoomControl,      
        mapTypeControl: mapOptions.mapTypeControl,  
        streetViewControl: mapOptions.streetViewControl 
    };

    map = new google.maps.Map(document.getElementById('map'), mapOptionsConfig);

    // Add markers with custom PinElement properties if provided
    if (Array.isArray(mapOptions.markers))
    {
        mapOptions.markers.forEach(markerData =>
        {

            const marker = new google.maps.Marker({
                position: { lat: markerData.latitude, lng: markerData.longitude },
                map: map,
                title: markerData.title || ""
            });

            if (markerData.pinElement)
            {
                const scale = markerData.pinElement.scale || 1;
                const glyphColor = markerData.pinElement.glyphColor || "white";
                const background = markerData.pinElement.background || "#B22222"; // Reddish color
                const borderColor = markerData.pinElement.borderColor || "black";

                // Custom SVG path for a pin shape
                const pinSvgPath = "M256 0C167.6 0 96 71.6 96 160c0 128 160 352 160 352s160-224 160-352C416 71.6 344.4 0 256 0z M256 240c-44.1 0-80-35.9-80-80s35.9-80 80-80 80 35.9 80 80-35.9 80-80 80z";

                const svgIcon = {
                    path: pinSvgPath,
                    fillColor: background,
                    fillOpacity: 1,
                    strokeColor: borderColor,
                    strokeWeight: 1,
                    scale: scale * 0.05, // Reduce scale for smaller pin
                    anchor: new google.maps.Point(256, 512), // Adjust anchor point
                };

                marker.setIcon(svgIcon);

                // Increase font size for label
                if (markerData.title)
                {
                    marker.setLabel({
                        text: markerData.title,
                        color: glyphColor,
                        fontSize: `${scale * 14}px`, // Larger font size
                        fontWeight: "bold",
                    });
                }
            }



        });
    }

}